import GameList from "../page_elements/GameList";
import {useParams} from 'react-router-dom';
import Topbar from '../page_elements/Topbar';

export default function ConsolePage(){
  
  const params = useParams();
  return <>
    <Topbar/>
    <GameList id={params.consoleId} />
  </>
}

